export default "__VITE_ASSET__BP1T5TSh__"